import { UnitService } from "./../../../services/catalogs/UnitService";
import { UnitDetail } from "../../../components/Pages/Catalogs/Unit/UnitDetail";
import { CreateUnitDto } from "../../../dtos/catalogs/unit/CreateUnitDto";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupUnit } from "../../../components/Shared/NewForms/NFLookupUnit";
import UnitList from "../../../components/Pages/Catalogs/Unit/UnitList";

export const Unit: IAppEntity = {
  entityType: "catalog",
  title: "Unit",
  pluralTitle: "Units",
  apiUrl: "units",
  apiEnum: ReferenceTypes.CatalogUnit,

  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(UnitDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(UnitList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupUnit, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new UnitService(this.apiUrl);
  },
  getEmptyModel(): CreateUnitDto {
    return {
      name: "",
    };
  },
};
